/*
    current MUI theme is not flexible and isn't being used for most of the components.
    Use this file to create a custom theme/colors that can be used throughout the application.
*/
export const colors = {
    white: '#FFF',
    brightTurquoise: '#00B6C9',
    lightBlue: '#00B6C9',
    lightCyan: '#C8E6F1',
    mediumCyan: '#004C60',
    mediumDarkCyan: '#00677F',
    darkBlue: '#051D33',
    darkCyan: '#007191',
    lightGrayBlue: '#E4EEEF',
    lightGrey: '#54575A',
    lighterGrey: '#EEE',
    lighestGrey: '#C3C3C3',
    lightSkyBlue: '#C8E6F1',
    mediumGrey: '#808285',
    transparentBlack: '#00000033',
    transparentLightGray: '#EEEEEEED',
    darkRed: '#AB1212',
};
export const CustomTheme = {
    container: {
        primary: colors.white,
        secondary: colors.lightGrayBlue,
    },
    text: {
        primary: colors.darkBlue,
        light: colors.lightGrey,
        danger: colors.darkRed,
    },
    border: {
        light: colors.lighterGrey,
    },
    special: {
        hr: colors.mediumGrey,
    },
    mediaQueries: {
        desktop: '@media (min-width: 768px)',
    },
};
